export const locale = {
  lang: 'tr',
  data: {
    ROLE: {
      Reading: 'Okuma',
      Writing: 'Yazma',
      Updateing: 'Güncelleme',
      Deleteing: 'Silme'
    },
    Definition: {
      User: {
        GetUsers: 'Tüm Kullanıcıları Görüntüleme',
        GetByIDUser:"Kullanıcı detayını görüntüleme",
        CreateUser: 'Kullanıcı Oluştur',
        UpdateUser: 'Kullanıcı Güncelle',
        GetRolestoUser: 'Kullanıcı Rolleri Al',
        AssignRoleToUser: 'Kullanıcıya Rol Ata',
        GetRolesToUser: 'Kullanıcı Rolleri Al',
        GetAccessibleMenusToUser: "Kullanıcıya Ait Sayfaları Getirme"
      },
      Roles: {
        GetRoles: 'Tüm Rolleri Getir',
        GetRoleById: 'Rolü Id\'ye Göre Al',
        CreateRole: 'Rol Oluştur',
        UpdateRole: 'Rol Güncelle',
        DeleteRole: 'Rolü Sil'
      },
      AuthorizationEndpoints: {
        GetRolesToEndpoint: 'Endpoint İçin Rolleri Getir',
        AssingRoleEndpoint: 'Role Endpoint Ata'
      },
      ApplicationServices: {
        GetAuthorizeDefinitionEndpoints: 'Yetki Tanım Endpoints Getir'
      },
      Action: {
        GetAllAction: 'Tüm Aksiyonları Getir',
        GetByIdAction: 'Aksiyon Detay',
        GetUserByIdAction: 'Kullanıcıya ait aksiyonlar',
        CreateAction: 'Aksiyon oluşturma',
        UpdateAction: 'Aksiyon Güncelleme',
        RemoveAction: 'Aksiyon Silme'
      },
      BrandModel: {
        GetAllBrandModel: 'Modelleri Görüntüleme',
        CreateBrandModel: 'Model Oluşturma',
        UpdateBrandModel: 'Model Güncelleme',
        RemoveBrandModel: 'Model Silme'
      },
      Brand: {
        GetListAllBrand: 'Marka Görüntüleme',
        CreateBrand: 'Marka Oluşturma',
        UpdateBrand: 'Marka Güncelleme',
        RemoveBrand: 'Marka Silme'
      },
      Category: {
        GetAllCategory: "Kategorileri görüntüle",
        GetByIdKindIdAllCategory: 'Türüne göre kategorileri görüntüleme',
        GetByIdCategory: 'Kategori Detayı',
        CreateCategory: 'Kategori Oluşturma',
        UpdateCategory: 'Kategori Güncelleme',
        RemoveCategory: 'Kategori Silme'
      },
      Company: {
        GetAllCompany: "Firmaları Görüntüler",
        GetAllDetailCompany: "Firmaların detaylı listesi",
        GetByIdCompany: "Firma detayını görüntüleme",
        GetByIdCompanyTransactions: "Firmaya ait işlemleri görüntüleme",
        GetByIdCompanyFiles: "Firma logalarını görüntüleme",
        ChangeCompanyFile: 'Firma logosunu güncelleme',
        RemoveCompanyFile: 'Firma logosunu silme',
        CreateCompany: 'Firma Oluşturma',
        ExcelCompanyUpload: 'Excelden Firma Ekleme',
        CompanyImageUpload: 'Firma logosu ekleme',
        UpdateCompany: 'Firma Güncelleme',
        RemoveCompany: 'Firma Silme'
      },
      CompanyVault: {
        CompaniesVaultGetAll: "Firma Hesap Hareketleri",
        CompanyByIdVaultGetAll: "Firmaya ait hesap hareketleri",
        CreateCompanyVault: "Firma hesap hareketi oluşturma"
      },
      Currency: {
        GetAllCurrency: "Para Birimlerini görüntüle",
        GetByIdCurrency: "Para Birimi detayı",
        CreateCurrency: "Para Birimi ekle",
        RemoveCurrency: "Para Birimi Sil",
        UpdateCurrency: "Para Birimi Güncelle"
      },
      Device: {
        GetAllDevices: "Tüm Cihazları Görüntüle",
        GetAllCompanyDevices: "Firma Cihazlarını Görüntüle",
        GetByIdDevice: "Cihaz Detayını Görüntüle",
        CreateDevice: "Cihaz Oluşturma",
        CreateBulkDevices: "Toplu Cihaz Teslim/Alım",
        UpdateDevice: "Cihaz Güncelleme",
        RemoveDevice: "Cihaz Silme"
      },
      Expense: {
        GetAllListExpense: "Masraf Listesi Görüntüleme",
        GetAllExpenses: "Masraf Listesi",
        GetByIdExpense: "Masraf detayı görüntüleme",
        CreateExpense: "Masraf Oluşturma",
        UpdateExpense: "Masraf Güncelleme",
        RemoveExpense: "Masraf Silme"
      },
      Kind: {
        GetAllByTypeNumberKinds: "Tip numarasına göre türler listesi",
        GetAllKinds: "Tür Listesi Görüntüleme",
        GetByIdKind: "Tür detay görüntüleme",
        GetByTypeNameKind: "Tür adına göre görüntüleme",
        CreateKind: "Tür Oluşturma",
        UpdateKind: "Tür Güncelleme",
        RemoveKind: "Tür Silme"
      },
      MainExpense: {
        GetAllMainExpenses: "Masraf Kalemi Listesi",
        GetAll: "Tüm Masraf Kalemleri",
        CreateMainExpenses: "Masraf Kalemi Oluşturma",
        UpdateMainExpenses: "Masraf Kalemi Güncelleme",
        RemoveMainExpenses: "Masraf Kalemi Silme"
      },
      PageUser: {
        CreatePageUsers: "Kullanıcıya Sayfa Verme",
        DeletePageUsers: "Kullanıcı Sayfasını Silme"
      },
      Payroll: {
        GetAllPayroll: "Tüm Bodro Görüntüleme",
        GetAllByPersonIdPayroll: "Personel bodrolarını görüntüleme",
        GetByIdPayroll: "Bodro Detayı",
        CreatePayroll: "Bodro Oluşturma",
        UpdatePayroll: "Bodro Güncelleme",
        RemovePayroll: "Bodro Silme"
      },
      Pdf: {
        GetAllPdf: "Tüm Pdfleri Görüntüleme",
        GetByIdPdf: "Pdf Detayı Görüntüleme",
        SendPdfMail: "Pdf ile mail yollıyabilme",
        UpdatePdf: "Pdf Güncelleme",
        RemovePdf: "Pdf Silme"
      },
      PersonLeave: {
        GetAllPersonLeave: "Personel İzinlerini Görüntüleme",
        GetByIdPersonLeave: "İzin Detayını Görüntüleme",
        GetPersonByIdLeaves: "Personele ait izinleri görüntüleme",
        CreateLeave: "Personel İzni Oluşturma",
        UpdateLeave: "Personel izni güncelleme",
        RemoveLeave: "Personel izni silme"
      },
      PersonPoint: {
        GetAllPersonPoint: "Tüm Personel Mesai Saatlerini Görüntüleme",
        GetAllPersonByIdPoints: "Personel Mesai Saatlerini Görüntüleme",
        GetByIdPoint: "Mesai Detayını Görüntüleme",
        CreatePoint: "Mesai Oluşturma",
        UpdatePoint: "Mesai Güncelleme",
        RemovePoint: "Mesai Silme"
      },
      Person: {
        GetAllPerson: "Tüm Personelleri Görüntüleme",
        GetByIdPerson: "Firma Personel Detay Görüntüleme",
        GetByIdWorker: "Çalışan Detay Görüntüleme",
        GetByIdCompanyPersons: "Firma Personellerini Görüntüle",
        CreatePerson: "Firma Yetkili Kişisi Oluşturma",
        CreateWorker: "Çalışan Oluşturma",
        CreateExcelPersons: "Excel İle Çalışan Yükleme",
        UpdateWorker: "Çalışan Güncelleme",
        UpdatePerson: "Firma Yetkili Kişisi Güncelleme",
        RemovePerson: "Personel Silme"
      },
      Product: {
        GetAllProduct: "Tüm Ürünleri Görüntüleme",
        GetByIdProduct: "Ürün Detayını Görüntüleme",
        CreateProduct: "Ürün Oluşturma",
        CreateExcelProduct: "Excelden Ürünler Yükleme",
        UpdateProduct: "Ürün Güncelleme",
        RemoveProduct: "Ürün Silme"
      },
      ProductMovement: {
        GetAllProductMovement: "Manuel Stok Hareketini Görünteleme",
        GetByIdProductMovement: "Ürüne Ait Manuel Stok Hareketlerini Görüntüleme",
        CreateProductMovement: "Manuel Stok Hareketi Oluşturma",
        UpdateProductMovement: "Manuel Stok Hareketi Güncelleme",
        RemoveProductMovement: "Manuel Stok Hareketi Silme"
      },
      ProductSerial: {
        GetAllSerialProduct: "Ürün Seri Numaraları Görüntüleme",
        GetByIdSerialProduct: "Ürüne Ait Seri Numaralarını Görüntüleme",
        CreateSerialProduct: "Ürün Seri Numarası Oluşturma",
        UpdateSerialProduct: "Ürün Seri Numarası Güncelleme",
        RemoveSerialProduct: "Ürün Seri Numarası Sime"
      },
      Project: {
        GetAllProject: "Tüm Projeleri Görüntüleme",
        GetByIdProject: "Proje Detayını Görüntüleme",
        CreateProject: "Proje Oluşturma",
        UpdateProject: "Proje Güncelleme",
        RemoveProject: "Proje Silme",
        CreateProjectFile: "Proje Dosya Ekleme",
        GetProjectFile: "Proje Dosyalarını Görüntüleme",
        RemoveProjectFile: "Proje Dosyasını Silme"
      },
      RequestTask: {
        GetAllRequestTasks: "Tüm Talepleri Görüntüleme",
        GetByIdCompanyAllRequestTasks: "Firmaya ait talepleri görüntüleme",
        GetByIdRequestTask: "Talep Detayını Görüntüleme",
        CreateRequestTask: "Talep Oluşturma",
        UpdateRequestTask: "Talep GÜncelleme",
        RemoveRequestTask: "Talep Silme",
        CreateRequestTaskFile: "Talepe Dosya Ekleme",
        GetRequestTaskFile: "Talep Dosyalarını Görüntüleme",
        RemoveRequestTaskFile: "Talep Dosyasını Silme"
      },
      Tax: {
        CreateTax: "Vergi Oluşturma",
        UpdateTax: "Vergi Güncelleme",
        RemoveTax: "Vergi Silme"
      },
      TransactionManagement: {
        GetAllTransaction: "Tüm İşlemleri Görüntüleme",
        GetCompanyByIdAllTransactions: "Firmaya ait işlemleri görüntüleme",
        GetAllFixtures: "Demirbaşları Görüntüleme",
        GetByIdTransaction: "İşlem Detayı Görüntüleme",
        GetAllExpenseList: "Tüm Masrafları Görüntüleme",
        GetByIdUserTransactions: "Kullanıcıya ait işlemler",
        UpdateByIdDetailTransactions: "İşlem güncelleme detayını görüntüleme",
        CreateTransactions: "İşlem Oluşturma",
        UpdateTransactions: "İşlem Güncelleme",
        UpdateStatusTransaction: "İşlem Durumu Güncelleme",
        UpdateExpenseTransaction: "Masraf Güncelleme",
        RemoveTransaction: "İşlem Silme"
      },
      UnitType: {
        CreateUnitType: "Birim Oluşturma",
        UpdateUnitType: "Birim Güncelleme",
        RemoveUnitType: "Birim Silme"
      },
      Warehouse: {
        GetByIdDetailWarehouse: "Depo Detaylarını Görüntüle",
        CreateWarehouse: "Depo Oluşturma",
        UpdateWarehouse: "Depo Güncelleme",
        RemoveWarehouse: "Depo silme"
      },
      Vault: {
        GetAllVault: "Tüm Hesapları Görüntüleme",
        GetByIdVault: "Hesap Detayı Görüntüleme",
        CreateVault: "Hesap Oluşturma",
        UpdateVault: "Hesap Güncelleme",
        RemoveVault: "Hesap Silme"
      },
      TransactionProducts: {
        GetByIdTransactionProducts: "İşlem ürünü detayını görüntüleme",
        TransactionByIdTransactionProducts: "İşlemin ürünlerini görüntüleme",
        CreateTransactionProducts: 'İşlem ürünü ekle',
        UpdateTransactionProducts: "İşlem ürünü güncelle",
        RemoveTransactionProduct: "İşlem ürünü silme"
      },
      Page:{
        GetAllPageList : "Sayfa listesini görüntüleme",
        GetByIdPage : "Sayfa detayını görüntüleme",
        CreatePage : "Sayfa Oluşturma",
        UpdatePage : "Sayfa Güncelleme",
        DeletePage : "Sayfa Silme"
      }
    }
  }
}